import { Divider, Flex, HStack, Skeleton, Text, VStack, } from '@chakra-ui/react';
import React from 'react';
import { useTokens } from '../../../context/TokenProvider';
import { makeReg4 } from '../../../styles/textStyles';
import { localise } from '../../../services/lang/lang';
import EpcChartBars from './EpcChartBars';
import EpcChartIndcators from './EpcChartIndicators';
const SMALLEST_WIDTH_PERCENTAGE = 45;
const WIDTH_PERCENTAGE_INCREMENT = 4.7;
const BAR_HEIGHT = '28px';
const EPCChart = ({ current, potential, bands, title, isLoading, ...rest }) => {
    const tokens = useTokens();
    return (React.createElement(VStack, { "data-testid": "epc_chart", align: "stretch", w: "100%", gap: tokens.Spacing02, ...rest },
        React.createElement(Skeleton, { isLoaded: !isLoading, height: BAR_HEIGHT },
            React.createElement(Text, { sx: makeReg4(tokens, { color: tokens.TextWhite100 }), h: BAR_HEIGHT, px: tokens.Spacing03, py: tokens.Spacing02, textAlign: "left", bg: "#0073BB", "data-testid": "epc_chart__title" }, title)),
        React.createElement(Flex, { "data-testid": "epc_chart__current_potential", justify: "flex-end" },
            React.createElement(HStack, { gap: "5px" },
                React.createElement(Skeleton, { isLoaded: !isLoading },
                    React.createElement(Text, { variant: "md-600-rg-6" }, localise('EPC_CHART_CURRENT'))),
                React.createElement(Divider, { orientation: "vertical", variant: "grey" }),
                React.createElement(Skeleton, { isLoaded: !isLoading },
                    React.createElement(Text, { variant: "md-600-rg-6" }, localise('EPC_CHART_POTENTIAL'))))),
        React.createElement(EpcChartBars, { bands: bands, barHeight: BAR_HEIGHT, smallestWidth: SMALLEST_WIDTH_PERCENTAGE, widthIncrement: WIDTH_PERCENTAGE_INCREMENT, isLoading: isLoading },
            React.createElement(EpcChartIndcators, { barHeight: BAR_HEIGHT, bands: bands, current: current, potential: potential, isLoading: isLoading }))));
};
export default EPCChart;
